<child-onboarding-container
  [formValid]="isFormValid$ | async"
  [loading]="store.sendingPersonalInformation$ | async"
  (back)="service.redirectToHome()"
  (forward)="submit()"
>
  <p class="zero-text p-huge-med">{{ 'child-onboarding.person.headline' | transloco }}</p>
  <div class="d-flex gap">
    @for (gender of genders; track $index) {
      <div
        class="gender px-3 py-2 zero-surface grey-800 cursor-pointer b-r-4 zero-text p-base-reg"
        [ngClass]="{
          'primary-400 btn': (gender$ | async) === gender,
          error: displayMissingGenderError$ | async,
        }"
        (click)="toggleGender(gender)"
      >
        {{ 'child-onboarding.person.genders.' + gender | transloco }}
      </div>
    }
  </div>
  <web-design-system-input
    class="d-block mt-4"
    [value]="name$ | async"
    [isValid]="name$ | async | notEmpty"
    [label]="'child-onboarding.person.name' | transloco"
    (valueChange)="handleNameChange($event)"
  />
  <web-design-system-input
    class="d-block mt-4"
    [value]="lastName$ | async"
    [isValid]="lastName$ | async | notEmpty"
    [label]="'child-onboarding.person.lastName' | transloco"
    (valueChange)="handleLastNameChange($event)"
  />

  <p class="zero-text p-huge-med mt-5">{{ 'child-onboarding.person.headline2' | transloco }}</p>
  <div class="d-flex gap justify-content-between">
    <web-design-system-input
      type="number"
      labelSize="small"
      [value]="birthDay$ | async"
      [isValid]="birthDay$ | async | underageDay: (birthMonth$ | async) : (birthYear$ | async)"
      [label]="'child-onboarding.person.birthDay' | transloco"
      (valueChange)="handleBirthDayChange($event)"
    />
    <web-design-system-input
      type="number"
      labelSize="small"
      [value]="birthMonth$ | async"
      [isValid]="birthMonth$ | async | underageMonth: (birthDay$ | async) : (birthYear$ | async)"
      [label]="'child-onboarding.person.birthMonth' | transloco"
      [focus]="(focussedField$ | async) === 'birthMonth'"
      (valueChange)="handleBirthMonthChange($event)"
    />
    <web-design-system-input
      type="number"
      labelSize="small"
      [value]="birthYear$ | async"
      [isValid]="birthYear$ | async | underageYear: (birthDay$ | async) : (birthMonth$ | async)"
      [label]="'child-onboarding.person.birthYear' | transloco"
      [focus]="(focussedField$ | async) === 'birthYear'"
      (valueChange)="handleBirthYearChange($event)"
    />
  </div>
  @if (birthdateError$ | async; as errorType) {
    @if (errorType !== 'invalid') {
      <p class="zero-text course-red p-small-reg mt-2">{{ 'child-onboarding.person.birth-date-error.boundaries' | transloco }}</p>
    } @else {
      <p class="zero-text course-red p-small-reg mt-2">{{ 'child-onboarding.person.birth-date-error.invalid' | transloco }}</p>
    }
  }
  <web-design-system-select
    class="d-block mt-4"
    [items]="countries$ | async"
    [placeholder]="'child-onboarding.person.country' | transloco"
    (selectItem)="selectCountry($event)"
  />
  <web-design-system-input
    class="d-block mt-4"
    [value]="city$ | async"
    [isValid]="city$ | async | notEmpty"
    [label]="'child-onboarding.person.city' | transloco"
    (valueChange)="handleCityChange($event)"
  />
</child-onboarding-container>
